import { Avatar, Box, IconButton, Typography } from "@mui/material";
import moment from "moment";
import { convertPrice } from "utils/currency.util";
import { DownloadFile } from "utils/download.util";
import { getUTCYMD } from "utils/timestamp.util";

const BookingDocumentItem = ({ item }: any) => {
  return (
    <Box
      sx={{
        border: "1px solid #DFDFDF",
        padding: "15px",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          borderBottom: "1px solid #E2E2E2",
          justifyContent: "space-between",
          pb: "15px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <Avatar
            src={item?.user?.image_url}
            sx={{ width: "56px", height: "56px" }}
          />
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flex: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: {
                    md: "18px",
                    lg: "18px",
                    xl: "18px",
                    sm: "15px",
                    xs: "15px",
                  },
                  lineHeight: "20px",
                }}
              >
                {item?.user?.name}
              </Typography>
            </Box>
          </Box>
        </Box>
        <img
          src="/assets/img/icons/arrow_down_cr.svg"
          alt=""
          onClick={() =>
            DownloadFile(
              "https://us-central1-haystackers-84f94.cloudfunctions.net/api/v1/public/Haystackers%20Privacy%20Policy%20and%20CA%20Privacy%20Policy.pdf",
              "Rules and Policy"
            )
          }
        />
      </Box>

      <Box sx={{ mt: "15px" }}>
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "26px",

            height: "48px",
          }}
        >
          {item?.booking_items?.[0]?.listings?.listing_name}
          &nbsp;&nbsp;
          {item?.booking_items.length > 1 && (
            <Typography
              component="span"
              sx={{
                color: "#307AFF",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              +{item?.booking_items.length - 1} more
            </Typography>
          )}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{
                color: "#A2A2A2",
                fontSize: "15px",
                fontWeight: 400,
                lineHeight: "28px",
              }}
            >
              Order ID -
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "15px",
                lineHeight: "28px",
              }}
            >
              #{item.id}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{
                color: "#A2A2A2",
                fontSize: "15px",
                fontWeight: 400,
                lineHeight: "28px",
              }}
            >
              Booked -
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "15px",
                lineHeight: "28px",
              }}
            >
              {`${moment(getUTCYMD(item.from_date)).format(
                "MMM DD"
              )} - ${moment(getUTCYMD(item.to_date)).format("MMM DD")}`}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BookingDocumentItem;
